<!-- src/components/ui-kit/NewUserModal.vue -->
<template>
    <div v-if="show" class="fixed inset-0 z-[2000] flex items-center justify-center">
        <!-- backdrop -->
        <div class="absolute inset-0 bg-black/50" @click="emitClose"></div>

        <!-- modal -->
        <div class="relative bg-[var(--theme-wise-background)] rounded-lg shadow-lg w-full max-w-md p-6 z-[1990]"
            role="dialog" aria-modal="true">
            <button class="absolute top-3 right-3 text-gray-600 hover:text-gray-800" @click="emitClose"
                aria-label="Close">
                ✖
            </button>

            <!-- Popup Title -->
            <h2 class="text-xl font-semibold mb-2 text-[var(--text-primary)] ">
                Welcome to the redesigned Sez Us!
            </h2>

            <!-- Popup Content -->
            <p class="mb-3 text-sm text-[var(--text-primary)]">
                Based on your input, we have refreshed the platform  — including simplified post reactions and an improved Civility Score.
            </p>

            <p class="mb-3 text-sm text-[var(--text-primary)]   ">
                While this isn’t a ranking system, the Civility Score makes it easy to see who is being respectful with interactions.
            </p>

            <ul class="list-disc pl-6 mb-3 text-sm text-[var(--text-primary)]" style="padding-left: 20px;    padding-bottom: 15px;">
                <li><strong>Green</strong> means you are engaging civilly.</li>
                <li><strong>Red</strong> means you have been less civil.</li>
            </ul>

            <p class="text-sm text-[var(--text-primary)] mb-4">
                Take a look around and let us know what you think at <strong>@sezus</strong>.
            </p>

            <!-- Buttons -->
            <div class="flex justify-end gap-3">                
                <button class="px-4 py-2 rounded bg-[#B44C6C] text-white hover:bg-[#C76383] disabled:opacity-60"
                    @click="onSaveClick" :disabled="saving">
                    <span v-if="saving">Saving...</span>
                    <span v-else>OK</span>
                </button>
            </div>
        </div>
    </div>
</template>


<script setup>
import { defineEmits, defineProps, ref } from 'vue';

const props = defineProps({
    show: { type: Boolean, default: false },
});
const emit = defineEmits(['close', 'save']);

const saving = ref(false);

const emitClose = () => {
    if (!saving.value) emit('close');
};

const onSaveClick = async () => {
    if (saving.value) return;
    saving.value = true;
    try {
        // emit 'save' to parent and parent will handle API and localStorage
        await emit('save');
    } finally {
        // parent might hide modal; ensure local saving state resets after short delay
        saving.value = false;
    }
};
</script>

<style scoped>
/* optional small tweaks */
</style>
